import {
  Button,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
const useStyle = makeStyles((theme) => ({
  hrMinWidth:{
    minWidth: "80px",
  },
  hrText:{
  marginLeft: 7 ,
  }
}));
export default function CommonButton({
  children,
  variant = "contained",
  disabled = false,
  type,
  color = "primary",
  loading ,
  startIcon,
  ...props
}) {
  const classes = useStyle();
  return (
    <Button
      variant={variant}
      disabled={disabled || loading}
      type={type}
      className={classes.hrMinWidth}
      startIcon={startIcon}
      color = {color}
      {...props}
    >
      {loading && <CircularProgress size={15} />}
      <span className={classes.hrText}>{children}</span>
    </Button>
  );
}
